export const TEST_CREDENTIAL_TYPES = {
    EMAIL: 'email',
    PHONE_NUMBER: 'phoneNumber',
    USERNAME: 'username'
};
//# sourceMappingURL=test-credential-types.js.map